export class Unit{
    text: string;
    expenseTypes: number[];
    constructor(text:string,expenseTypes:number[]){
        this.text=text;
        this.expenseTypes=expenseTypes;
    }
}